// client/src/components/Admin/InstitutionsReviCmp/InstitutionsReviFilters.js
//
// Barra de filtros del tab Instituciones (search + partner + active).

import React from "react";
import { Input, Select, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export function InstitutionsReviFilters({
  search,
  partner,
  active,
  partners,
  onChange,
}) {
  const partnerOptions = (partners || []).map((u) => ({
    value: u._id,
    label:
      `${u.firstname || ""} ${u.lastname || ""}`.trim() || u.email || u._id,
  }));

  return (
    <Space wrap style={{ marginBottom: 12 }}>
      <Input
        placeholder="Buscar por nombre o email"
        allowClear
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => onChange({ search: e.target.value })}
        style={{ width: 280 }}
      />
      <Select
        placeholder="Filtrar por partner"
        allowClear
        showSearch
        optionFilterProp="label"
        value={partner || undefined}
        onChange={(value) => onChange({ partner: value || "" })}
        options={partnerOptions}
        style={{ width: 240 }}
      />
      <Select
        placeholder="Estado"
        allowClear
        value={active === "" ? undefined : active}
        onChange={(value) =>
          onChange({ active: value === undefined ? "" : value })
        }
        options={[
          { value: "true", label: "Activas" },
          { value: "false", label: "Inactivas" },
        ]}
        style={{ width: 140 }}
      />
    </Space>
  );
}
